import { TextInput } from "@strapi/design-system";
import { useTranslation } from "react-i18next";

const SchoolRanking = ({ data, setData }) => {
  const { t } = useTranslation();
  const handleSetDomestic = (domestic) => {
    setData({ ...data, domestic });
  };

  const handleSetOrgRanking = (organization_rank) => {
    setData({ ...data, organization_rank });
  };

  const handleSetInternational = (international) => {
    setData({ ...data, international });
  };

  const handleSetNote = (note) => {
    setData({ ...data, note });
  };

  return (
    <div>
      <TextInput
        label={t("str_domestic")}
        name="domestic"
        onChange={(e) => handleSetDomestic(e.target.value)}
        value={data?.domestic || ""}
      />
      <br />
      <TextInput
        label={t("str_international")}
        name="international"
        onChange={(e) => handleSetInternational(e.target.value)}
        value={data?.international || ""}
      />
      <br />
      <TextInput
        label={t("str_ranking_organization")}
        name="organization_rank"
        onChange={(e) => handleSetOrgRanking(e.target.value)}
        value={data?.organization_rank || ""}
      />
      <br />
      <TextInput
        label={t("str_note")}
        name="note"
        onChange={(e) => handleSetNote(e.target.value)}
        value={data?.note || ""}
      />
    </div>
  );
};

export default SchoolRanking;
